'use client';

import { Text, Container } from '@weareconceptstudio/core';
import { config } from '@/helpers';

//* HOC's
import { withDataContext } from '@/context';

//* Components
import SkeletonFaq from './Skeleton';
import FaqAllItem from './FaqAllItem';
import Button from '@/components/Button';
import LazySection from '@/components/LazySection';

//* Style
import FaqContentStyle from './style';

const FaqSection = ({ globalData }) => {
	return globalData?.faq?.hasFaqs ? (
		<FaqContentStyle>
			<Container
				row
				isSection>
				<div className={'wrapper-container'}>
					<div className='faq-wrapper'>
						<Text
							tag={'h2'}
							className={'h2 title-faq'}>
							{globalData?.faq?.title}
						</Text>

						<Text className={'p p1 description-faq'}>{globalData?.faq?.description}</Text>

						{/* <Button
							text={'getInTouch'}
							className={'faq-button'}
							url={config.routes.privacyPolicy.path}
						/> */}
					</div>

					<div className='empty' />
					<LazySection
						delay={10}
						fallback={<SkeletonFaq />}>
						<FaqAllItem />
					</LazySection>
				</div>
			</Container>
		</FaqContentStyle>
	) : null;
};

export default withDataContext(FaqSection, ['globalData']);
